import { handleSignUpConfirmTrack } from '@/libs/metaPixel/track';
import { initEventBus, MetaTrackEvent } from '@repo/single-spa';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

const eventBus = initEventBus();

// TT-289: Vue publishes meta:track; the host owns the Pixel and makes the call
export function MetaEventHandler() {
  useEffect(() => {
    const handleTrack = (event: MetaTrackEvent) => {
      try {
        handleSignUpConfirmTrack(event);
      } catch (error) {
        // listeners run inside the publish call; never throw back into the confirm page
        Sentry.captureException(error);
      }
    };

    eventBus.on('meta:track', handleTrack);

    return () => {
      eventBus.off('meta:track', handleTrack);
    };
  }, []);

  return null;
}
